import { createContext } from 'react'
import type { ResolvedTheme, ThemeMode } from '@/lib/theme'

export type ThemeContextValue = {
  resolvedTheme: ResolvedTheme
  setTheme: (theme: ThemeMode) => void
  theme: ThemeMode
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
